<template>
    <div class="home-page ld-page" style="padding-top: 20px;">
		  <div class="">
		    <a class="logo" href="/"><img src="static/images/logo.png" /></a>
		  </div>
		<div class="home-content mt20">
      <div class="content crfff ac por">
       <div class="fs26 mt30">{{$t('landTips1')}}</div>
       <div class="ac mt10">
         <img width="80%" :src="isEN=='bur'?'../../static/images/ld-font1.png':'../../static/images/ld-font12.png'">
       </div>
        <div class="ac disflex mt20" style="justify-content: space-evenly;">
          <div v-if="showDaily" style="width: 45%;"  @click="getTypeLogin('daily')">
            <button class="button fw7" style="background:url(../../static/images/Daily.png) no-repeat 0 0;background-size: cover;width: 100%;width: 3rem;height: 0.89rem;">{{$t('Daily')}}</button>
          </div>
          <div v-if="showWeekly" style="width: 45%;" @click="getTypeLogin('weekly')">
            <button style="background:url(../../static/images/Weekly.png) no-repeat 0 0;background-size: cover;width: 100%;width: 3rem;height: 0.89rem;" class="button fw7">{{$t('Weekly')}}</button>
          </div>
        </div>
        <div class="fwb" v-if="show_usub" style="width: 90%; margin: 0.2rem auto 0;text-align: center;color: white;font-size: 0.4rem;margin-top: 0.2rem">
          <div>
            <span class="fs26">  {{$t('unsub_tip')}}</span>
          </div>
        </div>

        <div class="ac mt10">
          <img  width="80%" :src="isEN=='bur'?'../../static/images/ld-pz1.png':'../../static/images/ld-pz12.png'">
        </div>

        <div class="mt30">
          <div class=" al">
            <div class="two" @click="getTypeLogin('daily')" style="padding:0.2rem 0.2rem;min-height: auto;border-radius: 0.3rem;">
              <div class="fs36" style="margin-bottom: 10px;">{{$t('sexTitle1')}}</div>
              <div class="disflex">
                <div>
                  <img style="border-radius: 0.2rem;width: 3rem;" src="../../static/images/land-img1.jpg" />
                </div>
                <div class="" style="padding-left: 0.2rem;">
                  <span class="fs26">{{$t('landfont1')}}</span>
                  <button class="button mt30 crfff" style="width: auto;padding:0.1rem 0.2rem;">
                      {{$t('letgo')}}<img width="14" src="../../static/images/go.png" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ac otp-b disflex mt50" style="color: #fff;">
            <div class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
            <div class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        isShow:null,
        isEN:'bur',
        score:'',
        mobile:'',
        type:'daily',
        show_usub: false,
        showDaily: true,  // 控制 daily 的显示
        showWeekly: true,  // 控制 weekly 的显示
      }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    this.report_page();
    if (this.$route.query.msisdn){
      this.mobile = this.$route.query.msisdn
    }
    var type = this.$route.query.type
    if (type === 'day') {
      this.showDaily = true
      this.showWeekly = false
    } else if (type === 'week'){
      this.showWeekly = true
      this.showDaily = false
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
	},
    methods: {
      getType(type){
          this.$router.push({path:type});
      },
      getChange(type){
        let that = this
        this.isShow = type
        var channelId  = this.$route.query.channelId
        var tracker  = this.$route.query.tracker
        var code  = this.$route.query.code
        if(that.mobile==''){
          that.$router.push({path:'/login',query: {type:that.type,channelId:channelId,tracker:tracker,code:code}})
        }else{
          that.$router.push({path:'/purchaseChances2',query: {mobile:this.$route.query.msisdn,channelId:channelId,tracker:tracker,code:code}});
        }
      },
      getTypeLogin(type){
        this.type = type
        this.goLogin()
      },
      goLogin(){
        let that = this
        var channelId  = this.$route.query.channelId
        var tracker  = this.$route.query.tracker
        var code  = this.$route.query.code
        if(that.mobile==''){
          that.$router.push({path:'/login',query: {type:that.type,channelId:channelId,tracker:tracker,code:code}})
        }else{
          that.$parent.loadModal(true);
          var data = {
            mobile: that.mobile,
            type:that.type,
            channelId:channelId,
            tracker:tracker,
            code:code
          }
          that.$api.post('/api/user/sub',data,r =>{
            that.$parent.loadModal(false);
            if (r.code == 1){
              that.$parent.returnCode(r,function(){
                localStorage.setItem('token',r.data.userinfo.token)
                localStorage.setItem('mobile',r.data.userinfo.mobile)
                that.$router.push('/');
              });
            }else{
              that.$utils.alertText(r.msg,100, 3000);
            }
          })
        }
      },
      report_page(){
        let that = this
        let mobile = this.$route.query.msisdn;
        let data = {'type': 'land','mobile':mobile}
        that.$api.post('/api/report/process', data, r => {
          that.$parent.returnCode(r, function () {
            that.show_usub = r.data.show_usub
          })
        })
      }
	}
}
</script>
<style scoped>
  .close{
    background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 100px;
    height: 100px;
    font-size: 60px;
    margin: 30px auto 0;
    border-radius: 100px;
  }
  .new-img{margin: 40px 40px 0;width: auto;}
  .new-img .img-b{width: 48%;border: 4px solid #0062ff;
    border-radius: 10px;}
  .img-b img{width: 100%;border-radius: 10px;}
  .otp-b{justify-content: space-evenly;}
</style>



// WEBPACK FOOTER //
// src/page/land.vue